import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Amplitude plugin for event enrichment
 */

import { AMPLITUDE_EVENT_PREFIX, AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT, AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH, PAGE_VIEWED_EVENT_NAME } from './constants';
import { getBrowserDetails } from './browser-detection';
import { getOptimizelyExperimentData } from './optimizely';

// Store the latest page view event
var lastPageViewEvent = null;

/**
 * Creates a unified plugin that enriches all events with additional data
 * - For page view events: saves the entire event for later reference
 * - For component viewed events: adds the page_view property with stored page view event data
 * - For all events: adds optimizely_data and browser_details
 */
export function createUnifiedAmplitudePlugin() {
  return {
    name: 'unified-amplitude-plugin',
    type: 'enrichment',
    setup: function () {
      var _setup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function setup() {
        return _setup.apply(this, arguments);
      }
      return setup;
    }(),
    execute: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var optimizelyData, browserDetails;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Get enrichment data for all events
              optimizelyData = getOptimizelyExperimentData();
              browserDetails = getBrowserDetails(); // Case 1: Page view event - store it and add viewport data
              if (!(event.event_type === PAGE_VIEWED_EVENT_NAME)) {
                _context2.next = 6;
                break;
              }
              event.event_properties = _objectSpread(_objectSpread({}, event.event_properties), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT, window.innerHeight || undefined), AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH, window.innerWidth || undefined), "optimizely_data", optimizelyData), "browser_name", browserDetails.name), "browser_version", browserDetails.version));
              lastPageViewEvent = event;
              return _context2.abrupt("return", event);
            case 6:
              if (!(!event.event_type.startsWith(AMPLITUDE_EVENT_PREFIX) && lastPageViewEvent)) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, event), {}, {
                event_properties: _objectSpread(_objectSpread(_objectSpread({}, lastPageViewEvent.event_properties), event.event_properties), {}, {
                  optimizely_data: optimizelyData,
                  browser_name: browserDetails.name,
                  browser_version: browserDetails.version
                })
              }));
            case 8:
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, event), {}, {
                event_properties: _objectSpread(_objectSpread({}, event.event_properties), {}, {
                  optimizely_data: optimizelyData,
                  browser_name: browserDetails.name,
                  browser_version: browserDetails.version
                })
              }));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  };
}

/**
 * Retrieves the current Amplitude page view event if available
 */
export function getCurrentAmplitudePageView() {
  return lastPageViewEvent;
}

/**
 * Reset the page view event (useful for testing)
 * @internal
 */
export function resetPageViewEvent() {
  lastPageViewEvent = null;
}